<template lang="pug">
	section#banners(@mouseenter="stopAutoPlay", @mouseleave="startAutoPlay")
		.wrapper
			button(@click="toggleGaleria(bannerAtivo - 1)", :disabled="scrolling").seta.left
				img(:src="require('@images/icones/setaGaleria.png')")
			button(@click="toggleGaleria(bannerAtivo + 1)", :disabled="scrolling").seta.right
				img(:src="require('@images/icones/setaGaleria.png')")

		.galeria(:style="style", ref="galeriaTrack")
			.banner.last
				a(:href="lastBanner.has_link ? lastBanner.link : '#'", :target="lastBanner.has_link_externo ? '_blank' : ''")
					picture
						source(:srcset="lastBanner.banner_mobile_link", media="(max-width: 600px)")
						img(:src="lastBanner.banner_desktop_link")
			.banner(v-for="banner, index in banners")
				a(:href="banner.has_link ? banner.link : '#'", :target="banner.has_link_externo ? '_blank' : ''")
					Loader(tamanho="extra-large", v-if="loadingBanner").verde
					picture(v-show="!loadingBanner")
						source(:srcset="banner.banner_mobile_link", media="(max-width: 600px)")
						img(:src="banner.banner_desktop_link", @load="thumbLoaded(index)", @error="thumbLoaded(index)")
			.banner.first
				a(:href="firstBanner.has_link ? firstBanner.link : '#'", :target="firstBanner.has_link_externo ? '_blank' : ''")
					picture
						source(:srcset="firstBanner.banner_mobile_link", media="(max-width: 600px)")
						img(:src="firstBanner.banner_desktop_link")
		ul.dots
			li(v-for="i in banners.length", :class="{ ativo: bannerAtivo == i - 1 }", @click="toggleGaleria(i - 1)")
				i {{ i }}
</template>

<script>
    import Loader from '@components/Loader/Loader'

    export default {
        name: "section-banners",
        components: {
            Loader
        },
        data() {
            return {
                banners: [],
                bannerAtivo: 0,
                scrolling: false,
                autoplay: null,
                style: {
                    transform: `translateX(-100%)`,
                    transition: `all .5s ease`
                },
                isThumbsLoaded: [],
                posicaoInicial: 0,
                locked: false,
                loadingBanner: false
            }
        },
        created() {
            this.loadBanners()
        },
        mounted() {
            setTimeout(() => {
                this.$refs.galeriaTrack.addEventListener('touchstart', this.togglePositionInitial)
                this.$refs.galeriaTrack.addEventListener('touchend', this.toggleSwipeConceito)
            }, 2000)
        },
        computed: {
            lastBanner() {
                if (this.banners.length)
                    return this.banners[this.banners.length - 1]
                return {}
            },
            firstBanner() {
                if (this.banners.length)
                    return this.banners[0]
                return {}
            },
        },
        methods: {
            startAutoPlay() {
                this.autoplay = setTimeout(this.autoplayLoop, 4000)
            },
            stopAutoPlay() {
                clearTimeout(this.autoplay)
            },
            autoplayLoop() {
                this.toggleGaleria(this.bannerAtivo + 1)
                this.autoplay = setTimeout(this.autoplayLoop, 4000)
            },
            loadBanners() {

                this.$axios
                    .get(`home/banners`)
                    .then(response => this.banners = response.data)
                    .then(() => {
                        this.isThumbsLoaded = Array(this.banners.length).fill(false);
                        this.loadingBanner = false;
                    })
                    .then(this.startAutoPlay)
            },
            toggleGaleria(index) {
                this.scrolling = true
                if (index == 0) {
                    this.style.transform = `translateX(-100%)`
                } else if (index < 0) {
                    this.style.transform = `translateX(0%)`
                } else if (index > 0 && index <= this.banners.length) {
                    this.style.transform = `translateX(-${(index + 1) * 100}%)`
                }

                if (index >= this.banners.length) {
                    setTimeout(() => this.style.transition = `none`, 600)
                    setTimeout(() => this.style.transform = `translateX(-100%)`, 650)
                    setTimeout(() => this.style.transition = `all .5s ease`, 700)
                    setTimeout(() => this.scrolling = false, 700)
                    this.bannerAtivo = 0
                } else if (index < 0) {
                    setTimeout(() => this.style.transition = `none`, 600)
                    setTimeout(() => this.style.transform = `translateX(-${this.banners.length * 100}%)`, 650)
                    setTimeout(() => this.style.transition = `all .5s ease`, 700)
                    setTimeout(() => this.scrolling = false, 700)
                    this.bannerAtivo = this.banners.length - 1
                } else {
                    this.bannerAtivo = index
                    this.scrolling = false
                }
            },
            thumbLoaded(index) {
                this.isThumbsLoaded[index] = true;
                this.loadingBanner = false;
                for (let i = 0; i < this.isThumbsLoaded.length; i++) {
                    if (!this.isThumbsLoaded[i])
                        this.loadingBanner = true;
                }
            },
            toggleSwipeConceito(e) {
                e.preventDefault()
                let posicaoFinal = e.changedTouches[0].clientX
                let calc = this.posicaoInicial - posicaoFinal
                if (this.locked) {
                    this.toggleGaleria(calc > 0 ? this.bannerAtivo + 1 : this.bannerAtivo - 1)
                    this.locked = false
                }
                this.startAutoPlay()
            },
            togglePositionInitial(event) {
                // e.preventDefault()
                this.posicaoInicial = event.changedTouches[0].clientX
                this.locked = true
                this.stopAutoPlay()
            }
        },
    }
</script>

<style lang="stylus" scoped src="./Banners.styl"></style>